import { createFrontendPlugin } from '@backstage/frontend-plugin-api';
import { FormFieldBlueprint } from '@backstage/plugin-scaffolder-react/alpha';

// Owner-picker plugin: contributes the single `TeamOwnerPicker` scaffolder
// form field.
//
// MUST use createFrontendPlugin (NOT createFrontendModule) — modules attach to
// an existing plugin and are silently dropped if that plugin isn't registered.
// The extension itself attaches by *extension id*: FormFieldBlueprint's
// attachTo is `api:scaffolder/form-fields`, owned by the scaffolder plugin
// (auto-discovered via `app.packages: all`), so a field declared here still
// lands in the scaffolder's form-field registry. Wired in App.tsx `features:`.
//
// Alpha surface — re-verify on every `versions:bump`: `FormFieldBlueprint` +
// `createFormField` + `ScaffolderField` (@backstage/plugin-scaffolder-react/alpha).
export const ownerPickerPlugin = createFrontendPlugin({
  pluginId: 'owner-picker',
  title: 'Team owner picker',
  extensions: [
    FormFieldBlueprint.make({
      name: 'team-owner-picker',
      params: {
        field: () =>
          import('./extensions/teamOwnerPickerField').then(
            m => m.teamOwnerPickerFormField,
          ),
      },
    }),
  ],
});

export default ownerPickerPlugin;
